






















import { snakeCase } from 'lodash'
import { Component, Prop } from 'vue-property-decorator'

import { GroupedBotProperty } from '../../../../../../../../../BotProperties/components/Properties/types'
import { UseFields } from '../../../../../../../../../Pi'
import SetPropertyCondition from '../../../logic/ConditionTypes/SetPropertyConditions/SetPropertyCondition'

@Component({
  data() {
    return {
      snakeCase,
    }
  }
})
export default class SetConditionView extends UseFields {
  @Prop() condition!: SetPropertyCondition

  @Prop() properties!: Array<GroupedBotProperty>

  get property(): GroupedBotProperty | undefined {
    return this.properties.find((p) => p.id === this.condition.property_index)
  }
}
